import React from "react";
import { Button } from "./ui/Button";
import { SectionTag } from "./ui/SectionTag";

interface HeroProps {
  onContactClick?: () => void;
}

export const Hero: React.FC<HeroProps> = ({ onContactClick }) => {
  return (
    <div className="relative min-h-[92vh] overflow-hidden">
      {/* 2-Column Grid Layout */}
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[92vh] gap-2">
        {/* Left Column - Video */}
        <div className="relative min-h-[50vh] lg:min-h-[92vh] order-1 lg:order-1">
          <video
            src="/assets/video/coming-soon.webm"
            autoPlay
            loop
            muted
            playsInline
            className="absolute inset-0 w-full h-full object-cover"
          >
            Your browser does not support the video tag.
          </video>
          {/* Subtle overlay on video for better aesthetics */}
          <div className="absolute inset-0 bg-black/20"></div>


        </div>

        {/* Right Column - Text Content */}
        <div className="relative flex flex-col justify-center items-start px-8 lg:px-16 py-16 lg:py-24 bg-gray-900 order-2 lg:order-2">
          {/* Background Pattern/Texture (optional) */}
          <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-gray-800 to-black opacity-90"></div>

          {/* Content */}
          {/* Content */}
          <div className="relative z-10 flex flex-col gap-8 max-w-xl">
            {/* Main Heading */}
            {/* Text Overlay - "Our Company Tour" */}
            <SectionTag className="!mb-[-1rem] font-raleway">Our Company Tour</SectionTag>
            <h1 className="text-[36px] md:text-[48px] lg:text-[56px] font-bold font-open-sans-hebrew text-white leading-tight">
              Next-Generation Plywood for Modern Interiors
            </h1>

            {/* Subtext */}
            <p className="text-[16px] md:text-[18px] font-raleway text-gray-300 leading-relaxed">
              Engineered plywood and panel solutions crafted using next-generation
              technology, high-density hardwood cores, precision manufacturing,
              rigorous testing, and strict quality control.
            </p>

            {/* CTA Button */}
            <div>
              <Button variant="red" className="font-raleway" onClick={onContactClick}>
                Let's Discuss
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
